<template>
  <div>
    <project-index ref="projectTable" :tableColCheck="tableColCheck" plat-name="bz" system-type="funcGene">
<!--      <template slot="button">-->
<!--        <div style="margin-bottom: 15px">-->
<!--          <el-button-->
<!--              type="primary"-->
<!--              size="small"-->
<!--              @click="handleMergeProject">合并项目-->
<!--          </el-button>-->
<!--        </div>-->
<!--      </template>-->
    </project-index>
    <merge-project-dialog :show-dialog.sync="showMergeDialog" @updateData="updateData"></merge-project-dialog>
  </div>
</template>


<script>
import ProjectIndex from "@/components/project/ProjectIndex.vue";
import MergeProjectDialog from "@/components/project/bz/MergeProjectDialog.vue";

const baseURL = process.env.VUE_APP_BASE_API
export default {
  name: 'BZFunProject',
  components: {
    MergeProjectDialog,
    ProjectIndex

  },
  data() {
    return {
      tableColCheck: {
        isShow: true,
        name: 'bz_fun__col1'
      },
      showMergeDialog: false,

    }
  },
  methods: {
    handleMergeProject() {
      this.showMergeDialog = true
    },
    updateData(){
      this.showMergeDialog = false
      this.$refs.projectTable.getData()
    }
  }
}
</script>

<style scoped>
::v-deep .ant-table-empty .ant-table-body {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

::v-deep .ant-table-body {
  overflow-x: auto !important;
}

::v-deep.ant-table td {
  white-space: nowrap;
}

/deep/ .wMyTable .ant-table-body {
  max-height: 700px !important;
}

/deep/ .viewIcon i {
  color: #2978ca !important;
}
</style>

